module.exports = __webpack_public_path__ + "img/blue_160.c3ac1563.png";